import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  Button,
  TextField,
  Typography,
  Stepper,
  Step,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  FormGroup,
  Checkbox,
  Autocomplete,
  InputAdornment,
} from "@mui/material";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Link,
} from "@mui/material";
import TablePagination from "@mui/material/TablePagination";
import {
  KeyboardArrowLeft as KeyboardArrowLeftIcon,
  NavigateNext as NavigateNextIcon,
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  CancelPresentation as CancelPresentationIcon,
  Height,
} from "@mui/icons-material";
import Paper from "@mui/material/Paper";
import "../../../../index.css";
import { List, ListItem } from "@mui/material";
// import { styled } from "@mui/material/styles";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "../../../../lib/axios";
import { toast, ToastContainer } from "react-toastify";
import { ConfirmDialog } from "../../../ReusablePopup/CustomModel";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
// import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { z } from "zod";
import { isValidPinCode } from "../../../../lib/regexHelpers";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import {
  createPropertyDetails,
  deleteAmenities,
  deleteRecordByPropId,
  deleteWingByPropId,
  getAmenities,
  getAreaByPin,
  getPropertyDetails,
  getWingsFloors,
  updatePropertyDetails,
} from "../../../../Api/PropertyMst/Api";
import { errorFormatter } from "../../../../lib/helpers";
import CustomStepConnector from "../../../StyledComponents/CustomStepConnector";
import CustomStepIcon from "../../../StyledComponents/CustomStepIcon";
import CustomStepLabel from "../../../StyledComponents/CustomStepLabel";
import axiosInstance from "../../../../lib/axios";
import { formatDeleteErrorMessage } from "../../../../GlobalFunction/ErrorMessageHelper";
import checkAndLock from "../../../../GlobalFunction/checkAndLock";
import UnLock from "../../../../GlobalFunction/UnLock";
import CrudButtons from "../../../../../src//GlobalFunction/CrudButtons";
import { useReactToPrint } from "react-to-print";
import RefreshIcon from '@mui/icons-material/Refresh';
import CustomAutoCompleteNew from "../../../AutoComplete/CustomAutoCompleteNew";
import CustomAutocomplete from "../../../AutoComplete/AutocompletewithoutIcon";
import ReportTable from "../../../../atoms/ReportFolder/ReportTable";
import { useTrackVisit } from '../../../../hooks/useTrackVisit';


const steps = [
  "Property Details",
  "Floor Configuration",
  "Amenity Configuration",
];

const propMasterOneSchema = z.object({
  CompanyId: z.number().min(1, "Company Name is required"),
  BranchName: z.number().min(1, "Branch is required"),
  PropName: z.string().min(1, "Property Name is required"),
  PropTypName: z.number().min(1, "Property Type is required"),
  SqFt: z.string().optional(),
  Pincode: z.string().min(1, "Pincode is required"),
  Name: z.string().min(1, "Area is required"),
  CityName: z.string().optional(),
  StateName: z.string().optional(),
  CountryName: z.string().optional(),
  PropEmail: z
    .string()
    .max(0, "This is not a valid email")
    .or(z.string().trim().email("Invalid email address")),
  PropTel: z.string().optional(),
  PropMob: z
    .string()
    .trim()
    .max(0, "This is not a valid mobile no.")
    .or(z.string().regex(/^\d{10}$/, "Invalid mobile number")),
  TotalRooms: z.string().optional(),
  TotalBeds: z.string().optional(),
  HodEmpName: z.union([z.number().optional(), z.string().optional()]),
  WardenEmpName: z.union([z.number().optional(), z.string().optional()]),

  PropAdd: z.string().optional(),
  Remark: z.string().optional(),
});

const columns = [
  { id: "RowNum", label: "Sr.No.", minWidth: 1},
  { id: "PropName", label: "Property", minWidth: 170 },
  // { id: "PropTypName", label: "Type", minWidth: 100 },
  // { id: "SqFt", label: "SqFt", minWidth: 100 },
  { id: "PinCode", label: "PinCode", minWidth: 90 },
  { id: "CityName", label: "City", minWidth: 100 },
  { id: "PropMob", label: "Mobile", minWidth: 90 },
  { id: "TotalRooms", label: "Rooms", minWidth: 50 },
  { id: "TotalBeds", label: "Beds", minWidth: 50 },
  { id: "HodEmpName", label: "Hod", minWidth: 100 },
  // { id: "WardenEmpName", label: "Warden", minWidth: 100 },
  { id: "Status", label: "Status", minWidth: 100 },
];

const columnsData = [
  { id: "WingName", label: "WingName", minWidth: 60 },
  { id: "FloorName", label: "FloorName", minWidth: 60 },
];

const fields = [
  { id: "AmenityName", label: "Amenity", minWidth: 150 },
  { id: "Amenity_Desc", label: "Description", minWidth: 150 },
  { id: "AreaSqFt", label: "AreaSqFt", minWidth: 50 },
];

const FORM_INIT_STATE = {
  CompanyId: "",
  BranchName: "",
  PropName: "",
  SqFt: "",
  Pincode: "",
  Name: "",
  CityName: "",
  StateName: "",
  CountryName: "",
  PropEmail: "",
  PropTel: "",
  PropTypName: "",
  PropMob: "",
  TotalRooms: "",
  TotalBeds: "",
  PropImg: "",
  HodEmpName: "",
  WardenEmpName: "",
  PropAdd: "",
  PropGPSLoc: "",
  Status: "",
  Remark: "",
};

const StepperForm = () => {
  const location = useLocation();
  const userId = sessionStorage.getItem("UserId");
  const [activeStep, setActiveStep] = useState(0);
  const [errors, setErrors] = useState({});
  const [propertyId, setPropertyId] = useState(() => {
    if (location.state && location.state?.PropId) {
      return location.state && location.state?.PropId;
    }
    return undefined;
  });

  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState({
    isOpen: false,
    payload: null,
  });
  const [mode, setMode] = useState("view");
  const [hods, setHods] = useState([]);
  const [sites, setSites] = useState([]);
  const [propImg, setPropImg] = useState("");
  const [companies, setCompanies] = useState([]);
  const [wardens, setWardens] = useState([]);
  const [area, setArea] = useState([]);
  const [amenities, setAmenities] = useState([]);
  const [branch, setBranch] = useState([]);
  const [propType, setPropType] = useState([]);
  const [wings, setWings] = useState([]);
  const [floors, setFloors] = useState([]);
  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerms, setSearchTerms] = useState({});
  const [rowsData, setRowsData] = useState([]);
  const [entries, setEntries] = useState([]);
  const [field, setField] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [editState, setEditState] = useState({});

  const [selectAll, setSelectAll] = useState(false);
  const [wingSelectAll, setWingSelectAll] = useState(false);
  const [amenitySelectAll, setAmenitySelectAll] = useState(false);

  const [selectedAmenityIds, setSelectedAmenityIds] = useState([]);
  const [selectedFloorId, setSelectedFloorId] = useState(null);
  const [selectedWingId, setSelectedWingId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchFloorQuery, setSearchFloorQuery] = useState("");
  const [Status, setStatus] = useState("1");

  const [isRefPropTyp, setIsRefPropTyp] = useState(false);
  const [isRefHod, setIsRefHod] = useState(false);
  const [isRefWarden, setIsRefWarden] = useState(false);
  const [isRefWing, setIsRefWing] = useState(false);
  const [isRefFloor, setIsRefFloor] = useState(false);

  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });
  const { navigateAndTrack } = useTrackVisit("Property Master");

  const spinAnimationProp = {
    animation: isRefPropTyp ? 'spin 1s linear infinite' : 'none',
  };
  const spinAnimationHod = {
    animation: isRefHod ? 'spin 1s linear infinite' : 'none',
  };
  const spinAnimationWar = {
    animation: isRefWarden ? 'spin 1s linear infinite' : 'none',
  };
  const spinAnimationWing = {
    animation: isRefWing ? 'spin 1s linear infinite' : 'none',
  };
  const spinAnimationFloor = {
    animation: isRefFloor ? 'spin 1s linear infinite' : 'none',
  };

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
    setFormData((prevData) => ({
      ...prevData,
      Status: updatedStatus,
    }));
  };

  function updateFormOne(obj) {
    if (!obj) {
      return setFormData(FORM_INIT_STATE);
    }

    setFormData({
      PropId: obj.PropId,
      CompanyId: obj.CoMstId,
      BranchName: obj.CobrMstId,
      PropName: obj.PropName ?? "",
      SqFt: obj.SqFt?.toString(),
      Pincode: obj.PinCode ?? "",
      Name: obj.AreaName ?? "",
      StateName: obj.StateName ?? "",
      CountryName: obj.CountryName ?? "",
      CityName: obj.CityName ?? "",
      PropEmail: obj.PropEmail ?? "",
      PropTel: obj.PropTel ?? "",
      PropTypName: obj.PropTypeId ?? "",
      PropMob: obj.PropMob ?? "",
      TotalRooms: obj.TotalRooms?.toString(),
      TotalBeds: obj.TotalBeds?.toString(),
      PropImg: obj.PropImg,
      HodEmpName: obj.HodEmpId,
      WardenEmpName: obj.WardenEmpId,
      PropAdd: obj.PropAdd,
      PropGPSLoc: obj.PropGPSLoc,
      Status: obj.Status,
      Remark: obj.Remark || "",
    });
  }
  const openWingTab = () => {
    window.open("/wing")
  }
  const openFloorTab = () => {
    window.open("/floor")
  }

  const openNewTab = () => {
    window.open("/pincode");
  };
  const openPropType = () => {
    window.open("/propertyType-master");
  }
  const openWardenTab = () => {
    window.open("/usermst");
  };
  const openHodTab = () => {
    window.open("/usermst");
  }

  const handleRefreshFloors = async () => {
    setIsRefFloor(true);
    try {
      const response = await axios.post(`FloorMst/getFloorMstdrp`, {
        Flag: "R",
      });
      const { data: { Status, Data } } = response;
      if (Status === 0 && Array.isArray(Data)) {
        setFloors(Data);
      } else {
        setFloors([]);
      }
    } catch (error) {
      console.error("Error fetching Floors:", error);
    } finally {
      setTimeout(() => {
        setIsRefFloor(false);
      }, 300)
    }
  };
  const handleRefreshWings = async () => {
    setIsRefWing(true);
    try {
      const response = await axios.post(`WingMst/getMstWingdrp`, {
        Flag: "R",
      });
      const { data: { Status, Data } } = response;
      if (Status === 0 && Array.isArray(Data)) {
        setWings(Data);
      } else {
        setWings([]);
      }
    } catch (error) {
      console.error("Error fetching Wings:", error);
    } finally {
      setTimeout(() => {
        setIsRefWing(false);
      }, 300);
    }
  };

  const handleRefreshHod = async () => {
    setIsRefHod(true);
    try {
      const response = await axios.post(`MstEmp/getMstEmpdrp`, {
        Flag: parseInt(1),
      });
      const { data: { Status, Data } } = response;
      if (Status === 0 && Array.isArray(Data)) {
        setHods(Data);

      } else {
        setHods([]);
      }
    } catch (error) {
      console.error("Error fetching HODs:", error);

    } finally {
      setTimeout(() => {
        setIsRefHod(false);
      }, 300);
    }
  };

  const handleRefreshWarden = async () => {
    setIsRefWarden(true);
    try {
      const response = await axios.post(`MstEmp/getMstEmpdrp`, {
        Flag: parseInt(2),
      });
      const { data: { Status, Data } } = response;
      if (Status === 0 && Array.isArray(Data)) {
        setWardens(Data);
      } else {
        setWardens([]);
      }
    } catch (error) {
      console.error("Error fetching Wardens:", error);
    } finally {
      setTimeout(() => {
        setIsRefWarden(false);
      }, 300);
    }
  };

  const handlePropType = async () => {
    setIsRefPropTyp(true);
    try {
      const response = await axios.post(`PropTypeMst/getMstPropTypedrp`);
      const { data: { Status, Data } } = response;
      if (Status === 0 && Array.isArray(Data)) {
        setPropType(Data);
      } else {
        console.error("Failed to fetch Property Types");
      }
    } catch (error) {
      console.error("Error fetching Property Types. Please try again.");
    } finally {
      setTimeout(() => {
        setIsRefPropTyp(false);
      }, 300);
    }
  };

  const filteredWings = wings.filter((item) =>
    item.Name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const filteredFloors = floors.filter((item) =>
    item.Name.toLowerCase().includes(searchFloorQuery.toLowerCase())
  );

  const handleClearAllSelections = () => {
    setWings(
      (prevWings) => prevWings.map((wing) => ({ ...wing, isChecked: false })) // Set all wings' isChecked to false
    );
  };

  const handleClearAllFloorSelections = () => {
    setFloors(
      (prevFloors) =>
        prevFloors.map((floor) => ({ ...floor, isChecked: false })) // Set all floors' isChecked to false
    );
  };

  // Toggle the "Select All" checkbox
  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    const updatedItems = floors.map((item) => ({
      ...item,
      isChecked: newSelectAll,
    }));
    setFloors(updatedItems);
  };

  const amenitiesSelectAll = () => {
    const newSelectAll = !amenitySelectAll;
    setAmenitySelectAll(newSelectAll);
    const updatedItems = amenities.map((item) => ({
      ...item,
      isChecked: newSelectAll,
    }));
    setAmenities(updatedItems);
  };

  // Handle individual checkbox toggle
  const handleCheckboxChange = (Id) => {
    const updatedItems = floors.map((item) =>
      item.Id === Id ? { ...item, isChecked: !item.isChecked } : item
    );
    setFloors(updatedItems);

    // Update "Select All" checkbox based on individual selections
    const allChecked = updatedItems.every((item) => item.isChecked);
    setSelectAll(allChecked);
  };

  const wingCheckboxChange = (Id) => {
    const updatedItems = wings.map((item) =>
      item.Id === Id
        ? { ...item, isChecked: true }
        : { ...item, isChecked: false }
    );
    setWings(updatedItems);

    const selectedWing = updatedItems.find((item) => item.isChecked);
    setWingSelectAll([selectedWing]);
  };

  const amenityCheckboxChange = (Id) => {
    const updatedItems = amenities.map((item) =>
      item.Id === Id ? { ...item, isChecked: !item.isChecked } : item
    );
    setAmenities(updatedItems);

    const allChecked = updatedItems.every((item) => item.isChecked);
    setAmenitySelectAll(allChecked);
  };

  const fetchPropertyData = async (flag = "R", propId) => {
    const response = await getPropertyDetails(
      propId ? propId : propertyId,
      flag
    );
    if (response instanceof Error) {
      console.log(response.message);
    }
    const {
      data: { Status, responseStatusCode, Data, Message },
    } = response;
    if (Status === 0 && responseStatusCode === 1) {
      updateFormOne(Data[0]);
      setIsFormDisabled(true);
      setPropertyId(Data[0]?.PropId);
      setStatus(Data[0].Status.toString());
    } else {
      console.log(Message);
    }
  };

  const fetchWings = async (flag = "R") => {
    const response = await getWingsFloors({
      PropId: propertyId,
      Flag: flag,
    });
    if (response instanceof Error) {
      return toast.error("Error while fetching Wings and floors");
    }
    const {
      data: { Data },
    } = response;
    if (Array.isArray(Data)) {
      setRowsData(() => {
        return Data.map((row) => ({
          FloorId: row.FloorId,
          FloorName: row.FloorName,
          WingId: row.WingId,
          WingName: row.WingName,
          StartNo: row.StartNo,
          TotalRooms: row.TotalRooms,
        }));
      });
    } else {
      setRowsData([]);
    }
  };

  const fetchAmenities = async (flag = "R") => {
    const response = await getAmenities({
      PropId: propertyId,
      Flag: flag,
    });
    if (response instanceof Error) {
      return toast.error("Error while fetching Wings and floors");
    }
    const {
      data: { Data },
    } = response;
    if (Array.isArray(Data)) {
      setEntries(() => {
        return Data.map((row) => ({
          AmenityId: row.AmenityId,
          AmenityName: row.AmenityName,
        }));
      });
    } else {
      setEntries([]);
    }
  };

    useEffect(() => {
      const getRow = async () => {
        try {
          const res = await axiosInstance.post('PropertyMst/getAllPropertyMstDashBoard',  {
            start: 1,
          PageSize: 1,
          SearchText: userId,
          });
          if (res.data && res.data.Data) {
            setRows(res.data.Data);
            setDataForPrint(res.data.Data);
          } else {
            console.error('No data found in response');
          }
        } catch (err) {
          console.error('Error fetching data:', err);
        }
      };
  
      getRow();
    }, []);

  useEffect(() => {
    if (propertyId) {
      fetchPropertyData();
      fetchWings();
      fetchAmenities();
    } else {
      setMode("add");
      setIsFormDisabled(false);
    }
  }, [propertyId]);

  const [formData, setFormData] = useState(FORM_INIT_STATE);

  useEffect(() => {
    const fetchPropType = async () => {
      try {
        const response = await axios.post(`PropTypeMst/getMstPropTypedrp`);
        if (
          response.data.Status === 0 &&
          response.data.responseStatusCode === 1
        ) {
          setPropType(response.data.Data);
        } else {
          toast.error("Failed to fetch PropType");
        }
      } catch (error) {
        toast.error("Error fetching PropType. Please try again.");
      }
    };

    fetchPropType();
  }, []);

  //fetch api for company dropdown
  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await axios.post(`CoMst/getCoMstdrp`); //company dropdown api
        if (
          response.data.Status === 0 &&
          response.data.responseStatusCode === 1
        ) {
          setCompanies(response.data.Data);
        } else {
          toast.error("Failed to fetch CompanyName");
        }
      } catch (error) {
        console.error("Error fetching CompanyName:", error);
        toast.error("Error fetching CompanyName. Please try again.");
      }
    };

    fetchCompanies();
  }, []);

  //fetch api for company branch
  useEffect(() => {
    const fetchBranch = async (id) => {
      try {
        const response = await axios.post(`CoMst_Cobr/getCobrMstdrp`, {
          CoMstId: id,
        });
        if (
          response.data.Status === 0 &&
          response.data.responseStatusCode === 1
        ) {
          setBranch(response.data.Data);
        } else {
          toast.error("Failed to fetch Branch");
        }
      } catch (error) {
        toast.error("Error fetching Branch. Please try again.");
      }
    };

    if (formData.CompanyId) {
      fetchBranch(formData.CompanyId);
    }
  }, [formData.CompanyId]);

  //pincode api dropdown
  useEffect(() => {
    if (isValidPinCode(formData.Pincode)) {
      (async () => {
        const result = await getAreaByPin(formData.Pincode);
        if (result && Array.isArray(result)) {
          setArea(result);
        } else {
          setArea([]);
        }
      })();
    } else {
      setArea([]);
    }
  }, [formData.Pincode]);

  //api for city,state,country details
  useEffect(() => {
    const fetchPlaces = async (pincode, areaName) => {
      try {
        const { data } = await axios.post(
          `pincodeMst/getdrppincodeAreawise_datafill`, //
          {
            PinCode: parseInt(pincode),
            AreaName: areaName,
          }
        );
        if (data.Status === 0 && data.responseStatusCode === 1) {
          setSites(data.Data);
          const { CityName, StateName, CountryName, PinId, CityId } =
            data.Data[0];
          setFormData((prevData) => ({
            ...prevData,
            CityName,
            StateName,
            CountryName,
            PinId,
            CityId,
          }));
        }
      } catch (error) {
        toast.error("Error fetching PincodeArea. Please try again.");
      }
    };

    if (isValidPinCode(formData.Pincode) && formData.Name) {
      fetchPlaces(formData.Pincode.trim(), formData.Name);
    }
  }, [formData.Pincode, formData.Name]);
  //HOD EMP Dropdown....
  useEffect(() => {
    const fetchHods = async (flag) => {
      try {
        const response = await axios.post(`MstEmp/getMstEmpdrp`, {
          Flag: parseInt(1),
        });
        if (
          response.data.Status === 0 &&
          response.data.responseStatusCode === 1
        ) {
          setHods(response.data.Data);
        } else {
          toast.error("Failed to fetch Hods");
        }
      } catch (error) {
        toast.error("Error fetching Hods. Please try again.");
      }
    };

    fetchHods();
  }, []);

  //WARDEN  Dropdown....
  useEffect(() => {
    const fetchWardens = async (flag) => {
      try {
        const response = await axios.post(`MstEmp/getMstEmpdrp`, {
          Flag: parseInt(2),
        });
        if (
          response.data.Status === 0 &&
          response.data.responseStatusCode === 1
        ) {
          setWardens(response.data.Data);
        } else {
          toast.error("Failed to fetch Wardens");
        }
      } catch (error) {
        console.error("Error fetching Wardens:", error);
        toast.error("Error fetching Wardens. Please try again.");
      }
    };

    fetchWardens();
  }, []);

  useEffect(() => {
    const fetchWings = async (flag) => {
      try {
        const response = await axios.post(`WingMst/getMstWingdrp`, {
          Flag: flag,
        });
        if (
          response.data.Status === 0 &&
          response.data.responseStatusCode === 1
        ) {
          setWings(response.data.Data);
        } else {
          toast.error("Failed to fetch Wings");
        }
      } catch (error) {
        console.error("Error fetching Wings:", error);
        toast.error("Error fetching Wings. Please try again.");
      }
    };

    fetchWings();
  }, []);

  useEffect(() => {
    const fetchFloors = async (flag) => {
      try {
        const response = await axios.post(`FloorMst/getFloorMstdrp`, {
          Flag: flag,
        });
        if (
          response.data.Status === 0 &&
          response.data.responseStatusCode === 1
        ) {
          setFloors(response.data.Data);
        } else {
          setFloors([]);
        }
      } catch (error) {
        console.error("Error fetching Floors:", error);
      }
    };

    fetchFloors();
  }, []);

  useEffect(() => {
    const fetchAmenities = async () => {
      try {
        const response = await axios.post(`AmenityMst/getMstAmenitydrp`);
        if (
          response.data.Status === 0 &&
          response.data.responseStatusCode === 1
        ) {
          setAmenities(response.data.Data);
        } else {
          toast.error("Failed to fetch Amenities");
        }
      } catch (error) {
        console.error("Error fetching Amenities:", error);
        toast.error("Error fetching Amenities. Please try again.");
      }
    };

    fetchAmenities();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleSearchChange = (columnId, value) => {
    setSearchTerms((prev) => ({ ...prev, [columnId]: value }));
    setPage(0);
  };

  const filteredRows = React.useMemo(() => {
    return rowsData.filter((row) => {
      return Object.entries(searchTerms).every(([columnId, term]) => {
        if (!term) return true;
        const value = row[columnId];
        if (typeof value === "string") {
          return value.toLowerCase().includes(term.toLowerCase());
        } else if (typeof value === "number") {
          return value.toString().includes(term);
        } else if (typeof value === "object") {
          return false;
        }
        return true;
      });
    });
  }, [searchTerms, rowsData]);

  const filteredEntries = React.useMemo(() => {
    return entries.filter((row) => {
      return Object.entries(searchTerms).every(([columnId, term]) => {
        if (!term) return true;
        const value = row[columnId];
        if (typeof value === "string") {
          return value.toLowerCase().includes(term.toLowerCase());
        } else if (typeof value === "number") {
          return value.toString().includes(term);
        }
        return true;
      });
    });
  }, [searchTerms, entries]);

  // const handleRowDoubleClick = () => {
  //   navigate("", { state: { mode: "view" } });
  // };

  const navigate = useNavigate();

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: undefined,
    }));
  };

  const handleFloorConfig = (row, e) => {
    const { value, id } = e.currentTarget;

    const { WingId, FloorId } = row;

    const updatedRows = rowsData.map((row) => {
      if (row.WingId === WingId && row.FloorId === FloorId) {
        return {
          ...row,
          [id]: value,
        };
      }
      return row;
    });

    setRowsData(updatedRows);
  };

  const handleNextdata = async () => {
    if (!propertyId) return;
    await Promise.all([
      fetchPropertyData("N"),
      fetchWings("N"),
      fetchAmenities("N"),
    ]);
  };

  const handlePrevious = async () => {
    if (!propertyId && propertyId < 1) return;
    await Promise.all([
      fetchPropertyData("P"),
      fetchWings("P"),
      fetchAmenities("P"),
    ]);
  };

  const handleNext = () => {
    if (activeStep === 0) {
      const result = propMasterOneSchema.safeParse(formData);
      console.error("Validation failed:", result.error);

      if (!result.success) {
        toast.info("Please fill all required details");
        setErrors(errorFormatter(result.error.issues));
        return;
      }
    }
    if (activeStep === 1) {
      const hasData = () => rowsData.every((row) => row.StartNo && row.TotalRooms);
      if (!hasData()) {
        toast.error("Please fill all required details");
        return;
      }
    }

    if (activeStep === steps.length - 1) {
      // check if all checked amenities are in enteries
      const checkedAmenities = amenities.filter((a) => a.isChecked);

      let isAllSubmitted = true;
      checkedAmenities.forEach((a) => {
        const idx = entries.findIndex((entry) => entry.AmenityId === a.Id);
        if (idx === -1) {
          isAllSubmitted = false;
        }
      });

      if (isAllSubmitted === false) {
        return toast.info("Press confirm to save selected amenities.");
      }

      handleSubmit();
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSelect = () => {
    const selectedFloors = floors.filter((item) => item.isChecked);
    const selectedWings = wings.filter((item) => item.isChecked);

    if (selectedFloors.length < 1 || selectedWings.length < 1) {
      return toast.error("Please select both");
    }

    const dataToDisplay = [];

    selectedFloors.forEach((floor) => {
      selectedWings.forEach((wing) => {
        const alreadyAdded = rowsData.some(
          (row) => row.WingId === wing.Id && row.FloorId === floor.Id
        );

        if (!alreadyAdded) {
          dataToDisplay.push({
            FloorId: floor.Id,
            FloorName: floor.Name,
            WingId: wing.Id,
            WingName: wing.Name,
            TotalRooms: "",
            StartNo: "",
          });
        } else {
          toast.info(
            `Wing ${wing.Name} Floor ${floor.Name} has already been added.`
          );
        }

        setSelectedFloorId(floor.Id);
        setSelectedWingId(wing.Id);
      });
    });

    // Add new combinations to rowsData only if dataToDisplay is not empty
    if (dataToDisplay.length > 0) {
      const updatedRows = [...rowsData, ...dataToDisplay].sort((a, b) =>
        a.WingName.localeCompare(b.WingName)
      );
      setRowsData(updatedRows);
    }

    // Reset the checkboxes
    const resetFloors = floors.map((floor) => ({
      ...floor,
      isChecked: false,
    }));

    const resetWings = wings.map((wing) => ({
      ...wing,
      isChecked: false,
    }));

    setFloors(resetFloors);
    setWings(resetWings);
    setWingSelectAll(false);
    setSelectAll(false);
    setOpenConfirmDialog(false);
  };

  const deleteAmenityId = async (id) => {
    // Remove the entry with the specific AmenityId
    const response = await deleteAmenities(propertyId, id);
    if (response instanceof Error) {
      // console.log(response.message);
    }
    const {
      data: { Status, Data, Message },
    } = response;
    if (Status === 0 && Data && Data > 0) {
      toast.success(Message, { autoClose: 1000 });
      setEntries(entries.filter((entry) => entry.AmenityId !== id));
    }
  };

  const amenitySelect = () => {
    const selectedAmenities = amenities.filter((item) => item.isChecked);

    const dataToDisplay = selectedAmenities.map((a) => ({
      AmenityId: a.Id,
      AmenityName: a.Name,
    }));

    // REMOVING DUPLICATES
    const isInEntry = (id) => entries.find((entry) => entry.AmenityId === id);
    const filteredEntries = dataToDisplay.filter(
      (data) => !!isInEntry(data.AmenityId) === false
    );

    setEntries((prevRows) => [...prevRows, ...filteredEntries]);

    // If there is a first amenity, set the selected Amenity ID
    if (selectedAmenities.length > 0) {
      setSelectedAmenityIds(selectedAmenities.map((a) => a.Id));
    } else {
      setSelectedAmenityIds([]); // Clear if none selected
    }

    // Reset amenities
    const resetAmenities = amenities.map((amenity) => ({
      ...amenity,
      isChecked: false,
    }));

    setAmenities(resetAmenities);
    setAmenitySelectAll(false);
  };

  const handleSubmit = async () => {
    if (!userId) {
      toast.error("Error:UserId is missing in session");
      return;
    }

    const payload = {
      CobrMstId: parseInt(formData.BranchName),
      PropName: formData.PropName,
      PropTypeId: parseInt(formData.PropTypName),
      PinId: parseInt(formData.PinId),
      CityId: parseInt(formData.CityId),
      PropAdd: formData.PropAdd,
      PropImg: formData.PropImg,
      PropEmail: formData.PropEmail,
      PropTel: formData.PropTel,
      PropMob: formData.PropMob,
      SqFt: formData.SqFt,
      TotalRooms: formData.TotalRooms,
      TotalBeds: formData.TotalBeds,
      PropGPSLoc: formData.PropGPSLoc,
      HodEmpId: formData.HodEmpName ? parseInt(formData.HodEmpName) : 1,
      WardenEmpId: formData.WardenEmpName
        ? parseInt(formData.WardenEmpName)
        : 1,
      Status: formData.Status,
      Remark: formData.Remark || "testing",
    };

    if (mode === "edit" && propertyId) {
      // For update case
      payload.PropId = propertyId;
      payload.UpdatedBy = userId;
    }

    if (!propertyId) {
      // For create case
      payload.CreatedBy = userId;
    }

    try {
      const { data } =
        mode === "edit"
          ? await updatePropertyDetails(payload)
          : await createPropertyDetails(payload);

      let newPropId = propertyId;

      if (!propertyId && data.Data) {
        newPropId = data.Data;
        setPropertyId(newPropId);
      }

      const payloadFloor = rowsData.map((row) => ({
        PropId: newPropId,
        WingId: row.WingId,
        FloorId: row.FloorId,
        TotalRooms: row.TotalRooms,
        StartNo: row.StartNo,
      }));

      const payloadAmenity = entries.map((entry) => ({
        PropId: newPropId,
        AmenityId: entry.AmenityId,
      }));

      const result = {
        PropFloorConfig: payloadFloor,
      };

      let jsonData = JSON.stringify(result);

      jsonData = jsonData.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
      jsonData = '"' + jsonData + '"';

      const resultAmenity = {
        PropFloorConfig: payloadAmenity,
      };

      let jsonDataAmenity = JSON.stringify(resultAmenity);

      jsonDataAmenity = jsonDataAmenity
        .replace(/\\/g, "\\\\")
        .replace(/"/g, '\\"');
      jsonDataAmenity = '"' + jsonDataAmenity + '"';

      await Promise.all([
        axios.post("MstPropFloorConfig/ManageMstPropFloorConfig", jsonData),
        axios.post(
          "MstPropFloorConfig/ManageMstAmenityConfig",
          jsonDataAmenity
        ),
      ]);

      toast.success(data.Message, { autoClose: 1000 });

      setActiveStep(0);

      if (mode === "edit" && propertyId) {
        //UnLock api
        await UnLock(propertyId, "MstProperty", "PropId");
        setMode("view");
        setIsFormDisabled(true);
      } else {
        if (data.data && data.Data.PropId) {
          const newPropertyId = data.Data.PropId;
          setPropertyId(newPropertyId);

          await fetchPropertyData(newPropertyId, "R");
        }
        setMode("view");
        setIsFormDisabled(true);
      }
    } catch (error) {
      toast.error("Error submitting form");
    }
  };

  const handleAdd = () => {
    setMode("add");
    setIsFormDisabled(false);
    updateFormOne();

    setRowsData([]);
    setEntries([]);
    setActiveStep(0);
    setErrors({});
    setPropImg("");
  };

  const handleEdit = async () => {
    let Flag = await checkAndLock(propertyId, "MstProperty", "PropId");
    switch (Flag) {
      case 0:
        setIsFormDisabled(false);
        setMode("edit");
        break;
      case 1:
        toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  const handleCancel = async (flag = "L") => {
    if (mode === "add") {
      await fetchPropertyData("L", 1);
    } else {
      await UnLock(propertyId, "MstProperty", "PropId");
      await fetchPropertyData("R");
    }
    setMode("view");
  };

  // This opens add floor modal in 2nd step
  const addFloorHandler = () => {
    setOpenConfirmDialog(true);
  };

  const closeConfirmation = () => {
    setFloors(floors.map((floor) => ({ ...floor, isChecked: false })));
    setWings(wings.map((wing) => ({ ...wing, isChecked: false })));
    setOpenConfirmDialog(false);
  };

  const handleDelete = async (row, isPropDelete = false) => {
    let Flag = await checkAndLock(propertyId, "MstProperty", "PropId");
    switch (Flag) {
      case 0:
        setIsConfirmDialogOpen({ isOpen: true, payload: row, isPropDelete });
        break;
      case 1:
        toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  const handleConfirmDelete = async () => {
    try {
      if (isConfirmDialogOpen.isPropDelete) {
        // IF DELETE PROPERTY ICON CLICKED
        const response = await deleteRecordByPropId(propertyId);
        if (response instanceof Error) {
          toast.error(response.message);
        }

        const {
          data: { Status, Message, Data },
        } = response;

        if (Status === 0 && Array.isArray(Data) && Data.length > 0) {
          setIsConfirmDialogOpen({
            isOpen: false,
            payload: null,
            isPropDelete: false,
          });

          toast.success(Message, { autoClose: 1000 });
        } else {
          if (Array.isArray(Data) && Data.length > 0) {
            const msg = formatDeleteErrorMessage(Data);
            toast.error(msg, { autoClose: 1000 });
          } else {
            toast.error(Message, { autoClose: 1000 });
          }

          setIsConfirmDialogOpen({
            isOpen: false,
            payload: null,
            isPropDelete: false,
          });
        }
        await UnLock(propertyId, "MstProperty", "PropId");
        return;
      }

      const payload = isConfirmDialogOpen.payload;

      if (propertyId) {
        const result = await deleteWingByPropId({
          PropId: propertyId,
          WingId: payload.WingId ?? 0,
          FloorId: payload.FloorId ?? 0,
        });

        if (result instanceof Error) {
          return toast.error("Failed to delete wing");
        }
        const {
          data: { Status, Message },
        } = result;
        if (Status === 0 && Message) {
          setIsConfirmDialogOpen({
            isOpen: false,
            payload: null,
            isPropDelete: false,
          });

          if (!payload.WingId && !payload.FloorId) {
            await fetchWings();
          }
          toast.success(Message, { autoClose: 1000 });

          if (payload) {
            setRowsData((prevRows) =>
              prevRows.filter(
                (row) =>
                  row.WingId !== payload.WingId ||
                  row.FloorId !== payload.FloorId
              )
            );
            setMode("edit");
          }
        } else {
          toast.error(Message, { autoClose: 1000 });
          setIsConfirmDialogOpen({
            isOpen: false,
            payload: null,
            isPropDelete: false,
          });
        }
      } else {
        // Case add form state
        if (payload) {
          // it means only one row should be deleted
          setRowsData((prevRows) =>
            prevRows.filter(
              (row) =>
                row.WingId !== payload.WingId || row.FloorId !== payload.FloorId
            )
          );
        } else {
          setRowsData([]);
        }
      }
    } catch (error) {
      toast.error("Error deleting property. Please try again.");
    }
    setIsConfirmDialogOpen({ isOpen: false, payload: null });
  };

  const handleExit = () => {
    navigate("/propertytable", { replace: true });
  };

  // Handle file input change
  const handleImageChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();

      // Use a Promise to handle the file reading
      const readFileAsBase64 = (file) => {
        return new Promise((resolve, reject) => {
          reader.onloadend = () => {
            resolve(reader.result);
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      };

      // Read the file and update the state
      readFileAsBase64(file)
        .then((base64String) => {
          setFormData((prevData) => ({
            ...prevData,
            PropImg: base64String,
          }));
        })
        .catch((err) => {
          toast.error("Error reading file. Please try again.");
        });
    }
  };
  const handleClearImage = () => {
    setFormData((prevData) => ({
      ...prevData,
      PropImg: "",
    }));
  };
  const fileInput = document.getElementById("upload-photo");
  if (fileInput) {
    fileInput.value = "";
  }
  //Render step content...................
  const renderStepContent = (step) => {
    return (
      <Box sx={{ maxHeight: "auto", padding: "16px" }}>
        <ToastContainer />
        {(() => {
          switch (step) {
            case 0:
              return (
                <Grid
                  container
                  spacing={2}
                  sx={{
                    marginInline: "5px",
                    maxHeight: "50vh",
                    marginBlock: "5px",
                  }}
                >
                  <Grid container spacing={1}>
                    <Grid item lg={8} md={8} xs={12}>
                      <Box display="flex" flexDirection="column" gap={1}>
                        <Grid item lg={12} md={12} xs={12}>
                          {/* -  company name,branch-- */}
                          <Box display="flex" flexDirection="column" gap={1}>
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={6} className="form_field">


                                <CustomAutocomplete
                                  id="companyName-select"
                                  name="CompanyId"
                                  label={
                                    <span>
                                      Company Name <span style={{ color: "red" }}>*</span>
                                    </span>
                                  }
                                  options={companies}
                                  value={companies.find((company) => company.Id === formData.CompanyId) || ""}
                                  onChange={handleInputChange}
                                  disabled={isFormDisabled}
                                // helperText={formData.CompanyId ? '' : 'This field is required.'}
                                // error={!formData.CompanyId}

                                />
                              </Grid>
                              <Grid item xs={12} md={6} className="form_field">


                                <CustomAutocomplete
                                  id="branchName-select"
                                  name="BranchName"
                                  label={
                                    <span>
                                      Branch <span style={{ color: "red" }}>*</span>
                                    </span>
                                  }
                                  options={branch} // The list of branches
                                  value={branch.find((branchName) => branchName.Id === formData.BranchName) || ''} // Set the selected value
                                  onChange={handleInputChange} // Handle change
                                  disabled={isFormDisabled}
                                // helperText={formData.BranchName ? '' : 'This field is required.'} 
                                // error={!formData.BranchName} 

                                />
                              </Grid>
                            </Grid>
                          </Box>
                        </Grid>
                        {/* ------property name,type,sqft------------ */}
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              label={
                                <>
                                  Property Name{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </>
                              }
                              name="PropName"
                              value={formData.PropName}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                            />
                          </Grid>
                          <Grid item xs={12} md={3}>


                            <CustomAutoCompleteNew
                              id="propTypName-select"
                              name="PropTypName"
                              options={propType}
                              value={propType.find((type) => type.Id === formData.PropTypName) || ""}
                              // onChange={(event, newValue) => {
                              //   setFormData((prev) => ({
                              //     ...prev,
                              //     PropTypName: newValue ? newValue.Id : '',
                              //   }));
                              // }}
                              onChange={handleInputChange}
                              label={
                                <span>
                                  Property Type <span style={{ color: "red" }}>*</span>
                                </span>
                              }
                              disabled={isFormDisabled}
                              onAddClick={openPropType}
                              onRefreshClick={handlePropType}
                              isRefreshing={isRefPropTyp}
                            />
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <TextField
                              fullWidth
                              label="Sq.Ft Area"
                              name="SqFt"
                              value={formData.SqFt}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                              sx={{
                                "& .MuiInputLabel-root": {
                                  marginBottom: "0px",
                                },
                                "& .MuiFilledInput-root": {
                                  padding: "0px",
                                },
                              }}
                            />
                          </Grid>
                        </Grid>
                        {/* ------pincode,area,city,state------------ */}
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={3}>
                            <TextField
                              fullWidth
                              label={
                                <span>
                                  Pincode<span style={{ color: "red" }}>*</span>
                                </span>
                              }
                              name="Pincode"
                              value={formData.Pincode}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                              InputProps={{
                                endAdornment: !isFormDisabled && (
                                  <InputAdornment position="end">
                                    <AddIcon
                                      onClick={openNewTab}
                                      style={{ cursor: "pointer", fontSize: '16px', color: '#2196f3' }}
                                    />
                                    {/* <RefreshIcon
                                      // onClick={handleRefreshSuppliers}
                                      style={{ cursor: "pointer", fontSize: '16px',color: '#4caf50' }}
                                    /> */}
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} md={3} className="form_field">

                            <FormControl
                              variant="filled"
                              fullWidth
                              className="custom-select"
                            >
                              <InputLabel id="areaName-select-label">
                                Area <span style={{ color: "red" }}>*</span>
                              </InputLabel>
                              <Select
                                labelId="areaName-select-label"
                                id="areaName-select"
                                name="Name"
                                value={formData.Name}
                                onChange={handleInputChange}
                                className="custom-textfield"
                                disabled={isFormDisabled}
                              >
                                {area.length > 0 ? (
                                  area.map((areaItem) => (
                                    <MenuItem
                                      key={areaItem.Id}
                                      value={areaItem.Name}
                                    >
                                      {areaItem.Name}
                                    </MenuItem>
                                  ))
                                ) : (
                                  <MenuItem value="" disabled>
                                    No areas available
                                  </MenuItem>
                                )}
                              </Select>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} md={3}>
                            <TextField
                              fullWidth
                              label="City"
                              name="CityName"
                              value={formData.CityName}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                            />
                          </Grid>

                          <Grid item xs={12} md={3}>
                            <TextField
                              fullWidth
                              label="State"
                              name="StateName"
                              value={formData.StateName}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>

                    {/* Status,Photo */}
                    <Grid item lg={4} md={4} xs={12}>
                      <Grid
                        container
                        spacing={1}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "bottom",
                          position: "relative",
                        }}
                      >
                        <Grid
                          item
                          xs={12}
                          md={2}
                          lg={2}
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "bottom",
                            position: "sticky",
                            bottom: "0",
                          }}
                        >
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  disabled={mode === "view"}
                                  checked={Status === "1"}
                                  onChange={handleChangeStatus}
                                />
                              }
                              label="Status"
                            />
                          </FormGroup>
                        </Grid>
                        <Grid
                          item
                          lg={10}
                          md={10}
                          xs={12}
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                            gap={1}
                            border="1px solid #ccc"
                            borderRadius={1}
                            width={130}
                            height={150}
                            overflow="hidden"
                            position="relative"
                            disabled={isFormDisabled}
                          >
                            {formData.PropImg ? (
                              <img
                                src={formData.PropImg}
                                alt="Uploaded Preview"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            ) : (
                              <Typography
                                variant="body2"
                                color="textSecondary"
                                style={{ textAlign: "center", width: "10px" }}
                              >
                                Image Preview
                              </Typography>
                            )}
                          </Box>
                          <input
                            accept="image/*"
                            style={{ display: "none" }}
                            id="upload-photo"
                            type="file"
                            onChange={handleImageChange}
                          />
                          <label htmlFor="upload-photo">
                            <Button
                              // variant="contained"
                              disabled={isFormDisabled}
                              component="span"
                              style={{ marginTop: "0px", width: "10px" }}
                            >
                              Upload
                            </Button>
                          </label>
                          <Button
                            component="span"
                            disabled={isFormDisabled}
                            style={{ marginTop: "0px", width: "10px" }}
                            onClick={handleClearImage}
                          >
                            Clear
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>

                    {/* -------country,email,tel no.,mobile no.---------- */}
                    <Grid item lg={8} md={8} xs={12}>
                      <Box display="flex" flexDirection="column" gap={1}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={3}>
                            <TextField
                              fullWidth
                              label="Country"
                              name="CountryName"
                              value={formData.CountryName}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                            />
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <TextField
                              fullWidth
                              label={<span>Email ID</span>}
                              name="PropEmail"
                              value={formData.PropEmail}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                              error={Boolean(errors.PropEmail)}
                              helperText={errors.PropEmail}
                            />
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <TextField
                              fullWidth
                              label="Tel No"
                              name="PropTel"
                              value={formData.PropTel}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                            />
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <TextField
                              fullWidth
                              label="Mobile No"
                              name="PropMob"
                              value={formData.PropMob}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                              error={Boolean(errors.PropMob)}
                              helperText={errors.PropMob}
                            />
                          </Grid>
                        </Grid>
                        {/* ------------- */}
                        {/* //total rooms,totals beds ,hod,warden  */}
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={3}>
                            <TextField
                              fullWidth
                              label="Total Rooms"
                              name="TotalRooms"
                              value={formData.TotalRooms}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                            />
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <TextField
                              fullWidth
                              label="Total Beds"
                              name="TotalBeds"
                              value={formData.TotalBeds}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                            />
                          </Grid>
                          <Grid item xs={12} md={3} className="form_field">

                            {/* <FormControl
                              variant="filled"
                              fullWidth
                              className="custom-select"
                            >
                              <InputLabel id="hodEmpName-select-label">
                                HOD
                              </InputLabel>
                              <Select
                                labelId="hodEmpName-select-label"
                                id="hodEmpName-select"
                                name="HodEmpName"
                                value={formData.HodEmpName}
                                onChange={handleInputChange}
                                className="custom-textfield"
                                disabled={isFormDisabled}
                                sx={{
                                  borderRadius: 1,
                                  paddingRight: '30px',
                                }}

                                endAdornment={!isFormDisabled && (
                                  <InputAdornment position="end">
                                    <AddIcon
                                      onClick={openHodTab}
                                      style={{ cursor: "pointer", fontSize: '16px', color: '#2196f3' }}
                                    />
                                    <RefreshIcon
                                      onClick={handleRefreshHod}
                                      sx={{
                                        transition: 'transform 0.3s ease',
                                        cursor: 'pointer',
                                        fontSize: '18px',
                                        color: '#4caf50',
                                      }}
                                      style={spinAnimationHod}

                                    />
                                    <style>
                                      {`
              @keyframes spin {
                from {
                  transform: rotate(0deg);
                }
                to {
                  transform: rotate(360deg);
                }
              }
            `}
                                    </style>
                                  </InputAdornment>
                                )
                                }
                              >
                                {hods.map((hodEmpName) => (
                                  <MenuItem
                                    key={hodEmpName.Id}
                                    value={hodEmpName.Id}
                                  >
                                    {hodEmpName.Name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl> */}
                            <CustomAutoCompleteNew
                              id="hodEmpName-select"
                              name="HodEmpName"
                              options={hods}
                              value={hods.find((hod) => hod.Id === formData.HodEmpName) || ""}
                              // onChange={(event, newValue) => {
                              //   setFormData((prev) => ({
                              //     ...prev,
                              //     HodEmpName: newValue ? newValue.Id : '',
                              //   }));
                              // }}
                              onChange={handleInputChange}
                              label="HOD"
                              disabled={isFormDisabled}
                              onAddClick={openHodTab}
                              onRefreshClick={handleRefreshHod}
                              isRefreshing={isRefHod}
                            />
                          </Grid>
                          <Grid item xs={12} md={3} className="form_field">

                            {/* <FormControl
                              variant="filled"
                              fullWidth
                              className="custom-select"
                            >
                              <InputLabel id="wardenEmpName-select-label">
                                Warden
                              </InputLabel>
                              <Select
                                labelId="wardenEmpName-select-label"
                                id="wardenEmpName-select"
                                name="WardenEmpName"
                                value={formData.WardenEmpName}
                                onChange={handleInputChange}
                                className="custom-textfield"
                                disabled={isFormDisabled}
                                sx={{
                                  borderRadius: 1,
                                  paddingRight: '30px',
                                }}

                                endAdornment={!isFormDisabled && (
                                  <InputAdornment position="end">
                                    <AddIcon
                                      onClick={openWardenTab}
                                      style={{ cursor: "pointer", fontSize: '16px', color: '#2196f3' }}
                                    />
                                    <RefreshIcon
                                      onClick={handleRefreshWarden}
                                      sx={{
                                        transition: 'transform 0.3s ease',
                                        cursor: 'pointer',
                                        fontSize: '18px',
                                        color: '#4caf50',
                                      }}
                                      style={spinAnimationWar}
                                    />
                                    <style>
                                      {`
              @keyframes spin {
                from {
                  transform: rotate(0deg);
                }
                to {
                  transform: rotate(360deg);
                }
              }
            `}
                                    </style>
                                  </InputAdornment>
                                )
                                }
                              >
                                {wardens.map((wardenEmpName) => (
                                  <MenuItem
                                    key={wardenEmpName.Id}
                                    value={wardenEmpName.Id}
                                  >
                                    {wardenEmpName.Name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl> */}
                            <CustomAutoCompleteNew
                              id="wardenEmpName-select"
                              name="WardenEmpName"
                              options={wardens}
                              value={wardens.find((warden) => warden.Id === formData.WardenEmpName) || ""}
                              // onChange={(event, newValue) => {
                              //   setFormData((prev) => ({
                              //     ...prev,
                              //     WardenEmpName: newValue ? newValue.Id : '',
                              //   }));
                              // }}
                              onChange={handleInputChange}
                              label="Warden"
                              disabled={isFormDisabled}
                              onAddClick={openWardenTab}
                              onRefreshClick={handleRefreshWarden}
                              isRefreshing={isRefWarden}
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                    <Grid item lg={4} md={4} xs={12}>
                      <Box display="flex" flexDirection="column" gap={1}>
                        <Grid sx={{ paddingRight: "50px" }}>
                          <TextField
                            fullWidth
                            label="Address"
                            name="PropAdd"
                            value={formData.PropAdd}
                            onChange={handleInputChange}
                            multiline
                            rows={1}
                            variant="filled"
                            disabled={isFormDisabled}
                            className="custom-textfield"
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "90px",
                                //  maxWidth:"450px"
                              },
                              "& .MuiInputBase-input": {
                                resize: "vertical",
                              },
                              "& .MuiFilledInput-root": {
                                "&:hover": {
                                  backgroundColor: "transparent",
                                },
                                "&.Mui-focused": {
                                  backgroundColor: "transparent",
                                },
                              },
                            }}
                          />
                        </Grid>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              );

            case 1:
              return (
                <>
                  <Grid
                    container
                    spacing={2}
                    sx={{
                      maxHeight: "50vh",

                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Box>
                      <Grid
                        container
                        gap={2}
                        sx={{
                          padding: "5px 0px",
                          display: "flex",
                          justifyContent: "right",
                          alignItems: "right",
                          marginRight: "0px",
                        }}
                      >
                        <Button
                          variant="contained"
                          onClick={addFloorHandler}
                          disabled={isFormDisabled}
                          color="primary"
                          sx={{
                            background: "#635bff",
                            color: "white",
                            borderRadius: "50px",
                            padding: "8px 20px",
                            boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.3)",
                            transition: "background 0.3s ease",
                          }}
                          size="small"
                        >
                          Add Floor
                        </Button>
                        <Button
                          variant="contained"
                          disabled={isFormDisabled}
                          onClick={() => handleDelete(null)}
                          color="primary"
                          sx={{
                            background: "#635bff",
                            color: "white",
                            borderRadius: "50px",
                            padding: "8px 20px",
                            boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.3)",
                            transition: "background 0.3s ease",
                          }}
                          size="small"
                        >
                          Clear All
                        </Button>
                      </Grid>
                      <Paper
                        size="small"
                        sx={{
                          minWidth: "100%",
                          overflow: "hidden",
                          margin: "0px 0px 0px 0px",
                          border: "1px solid lightgray",
                        }}
                      >
                        <TableContainer sx={{ maxHeight: 270 }}>
                          <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                              <TableRow
                                sx={{
                                  "& > th": {
                                    padding: "2px  10px 2px  24px",
                                  },
                                }}
                              >
                                {columnsData.map((column) => (
                                  <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                  >
                                    <Typography
                                      variant="subtitle1"
                                      fontWeight="bold"
                                    >
                                      {column.label}
                                    </Typography>
                                    <TextField
                                      size="small"
                                      variant="outlined"
                                      placeholder={`Search ${column.label}`}
                                      onChange={(e) =>
                                        handleSearchChange(
                                          column.id,
                                          e.target.value
                                        )
                                      }
                                      sx={{
                                        mt: 1,
                                        margin: "0px",
                                        "& .MuiOutlinedInput-input": {
                                          padding: "2px 4px",
                                          width: "100px",
                                        },
                                      }}
                                    />
                                  </TableCell>
                                ))}

                                <TableCell>
                                  <Typography
                                    variant="subtitle1"
                                    fontWeight="bold"
                                  >
                                    Total Rooms
                                  </Typography>
                                  <TextField
                                    size="small"
                                    variant="outlined"
                                    placeholder={`Search Total Rooms`}
                                    onChange={(e) =>
                                      handleSearchChange(
                                        "TotalRooms",
                                        e.target.value
                                      )
                                    }
                                    sx={{
                                      mt: 1,
                                      margin: "0px",
                                      "& .MuiOutlinedInput-input": {
                                        padding: "2px 6px",
                                        width: "100px",
                                      },
                                    }}
                                  />
                                </TableCell>
                                <TableCell>
                                  <Typography
                                    variant="subtitle1"
                                    fontWeight="bold"
                                  >
                                    Start No.
                                  </Typography>
                                  <TextField
                                    size="small"
                                    variant="outlined"
                                    placeholder={`Search Start No.`}
                                    onChange={(e) =>
                                      handleSearchChange(
                                        "StartNo",
                                        e.target.value
                                      )
                                    }
                                    sx={{
                                      mt: 1,
                                      margin: "0px",
                                      "& .MuiOutlinedInput-input": {
                                        padding: "2px 6px",
                                        width: "100px",
                                      },
                                    }}
                                  />
                                </TableCell>
                                <TableCell sx={{ ml: 2, mr: 2, width: "20px" }}>
                                  <Typography
                                    variant="subtitle1"
                                    fontWeight="bold"
                                    sx={{ pl: 2, pr: 2 }}
                                  >
                                    Action
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {filteredRows
                                .sort((a, b) => {
                                  const wingA = a.Wing || ""; // Default to empty string
                                  const wingB = b.Wing || ""; // Default to empty string
                                  return wingA.localeCompare(wingB);
                                })
                                .slice()
                                .map((row) => {
                                  return (
                                    <TableRow
                                      hover
                                      role="checkbox"
                                      tabIndex={-1}
                                      key={row.propertyId}
                                      // onDoubleClick={() =>
                                      //   handleRowDoubleClick(row)
                                      // }
                                      style={{ cursor: "pointer" }}
                                      sx={{
                                        "& > td": {
                                          padding: "2px  14px 2px  24px",
                                        },
                                      }}
                                    >
                                      {columnsData.map((column) => {
                                        const value =
                                          editState[row.propertyId]?.[
                                          column.id
                                          ] ?? row[column.id];
                                        return (
                                          <TableCell
                                            key={column.id}
                                            align={column.align}
                                          >
                                            {value}
                                          </TableCell>
                                        );
                                      })}

                                      <TableCell>
                                        <TextField
                                          id="TotalRooms"
                                          size="small"
                                          value={row.TotalRooms}
                                          disabled={isFormDisabled}
                                          onChange={(e) =>
                                            handleFloorConfig(row, e)
                                          }
                                          sx={{
                                            "& .MuiOutlinedInput-input": {
                                              padding: "2px 6px",
                                              width: "100px",
                                            },
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <TextField
                                          id="StartNo"
                                          size="small"
                                          value={row.StartNo}
                                          disabled={isFormDisabled}
                                          onChange={(e) =>
                                            handleFloorConfig(row, e)
                                          }
                                          sx={{
                                            "& .MuiOutlinedInput-input": {
                                              padding: "2px 6px",
                                              width: "100px",
                                            },
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell sx={{ padding: 0 }}>
                                        <Box>
                                          <Button
                                            disabled={isFormDisabled}
                                            onClick={() => handleDelete(row)}
                                            sx={{
                                              padding: 0,
                                              margin: "0px 0px 0px 20px",
                                              minWidth: "auto",
                                            }}
                                            size="small"
                                          >
                                            <DeleteIcon
                                              sx={{
                                                margin: "0px 0px 0px 0px",
                                              }}
                                            />
                                          </Button>
                                        </Box>
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Paper>
                      {/* </Box> */}
                    </Box>
                  </Grid>
                </>
              );

            case 2:
              return (
                <>
                  <Box
                    sx={{
                      maxWidth: "80vw",
                      overflowX: "hidden",
                      display: "flex",
                    }}
                  >
                    <Grid item lg={12} md={12} xs={12}>
                      <Box>
                        <Grid
                          container
                          spacing={12}
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            gap: 0,
                            marginInline: "0px",
                          }}
                        >
                          <Grid
                            item
                            xs={12}
                            md={2}
                            className="form_field"
                            sx={{ marginTop: "0px", paddingTop: "0px" }}
                          >
                            <List
                              sx={{
                                marginTop: "0px",
                                paddingTop: "0px",
                                width: "200px",
                              }}
                            >
                              <span
                                style={{ fontWeight: 900, fontSize: "20px" }}
                              >
                                Select Amenities{" "}
                              </span>

                              <ListItem
                                style={{ maxHeight: "200px", width: "auto" }}
                              >
                                <Grid>
                                  <label
                                    sx={{
                                      marginTop: "10px",
                                      paddingTop: "0px",
                                    }}
                                  >
                                    <input
                                      disabled={isFormDisabled}
                                      type="checkbox"
                                      checked={amenitySelectAll}
                                      onChange={amenitiesSelectAll}
                                    />
                                    Select All
                                  </label>

                                  <Grid
                                    style={{
                                      maxHeight: "170px",
                                      overflowY: "auto",
                                      marginTop: "5px",
                                      maxWidth: "auto",
                                      paddingTop: "0px",
                                    }}
                                  >
                                    {amenities.map((item) => (
                                      <div key={item.Id}>
                                        <label>
                                          <input
                                            disabled={isFormDisabled}
                                            type="checkbox"
                                            checked={item.isChecked}
                                            onChange={() =>
                                              amenityCheckboxChange(item.Id)
                                            }
                                          />
                                          {item.Name}
                                        </label>
                                      </div>
                                    ))}
                                  </Grid>
                                </Grid>
                              </ListItem>
                              <Button
                                variant="contained"
                                disabled={isFormDisabled}
                                color="primary"
                                sx={{
                                  // background: "linear-gradient(45deg, #635bff, #1E90FF)",
                                  background: "#635bff",
                                  color: "white",
                                  borderRadius: "50px",
                                  padding: "8px 20px",
                                  boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.3)",
                                  transition: "background 0.3s ease",
                                }}
                                size="small"
                                onClick={amenitySelect}
                              >
                                Confirm
                              </Button>
                            </List>
                          </Grid>
                          <Grid item xs={12} md={10} className="form_field">
                            <Paper
                              sx={{
                                width: "80%",
                                overflow: "hidden",

                                padding: "0px 15px 0px 15px",
                                border: "1px solid lightgray",
                              }}
                            >
                              <TableContainer sx={{ maxHeight: 450 }}>
                                <Table stickyHeader aria-label="sticky table">
                                  <TableHead>
                                    <TableRow
                                      sx={{
                                        "& > th": {
                                          padding: "2px  0px 2px  0px",
                                        },
                                      }}
                                    >
                                      {fields.map((column) => (
                                        <TableCell
                                          key={column.id}
                                          align={column.align}
                                          style={{ minWidth: column.minWidth }}
                                        >
                                          <Typography
                                            variant="subtitle1"
                                            fontWeight="bold"
                                          >
                                            {column.label}
                                          </Typography>
                                          <TextField
                                            size="small"
                                            variant="outlined"
                                            placeholder={`Search ${column.label}`}
                                            onChange={(e) =>
                                              handleSearchChange(
                                                column.id,
                                                e.target.value
                                              )
                                            }
                                            sx={{
                                              mt: 1,
                                              margin: "0px",
                                              "& .MuiOutlinedInput-input": {
                                                padding: "2px 6px",
                                                width: "110px",
                                              },
                                            }}
                                          />
                                        </TableCell>
                                      ))}
                                      <TableCell sx={{}}>
                                        <Typography
                                          variant="subtitle1"
                                          fontWeight="bold"
                                        >
                                          Action
                                        </Typography>
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {filteredEntries
                                      .slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                      )
                                      .map((row) => {
                                        return (
                                          <TableRow
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={row.PropId}
                                            style={{ cursor: "pointer" }}
                                            sx={{
                                              "& > td": {
                                                padding: "2px  0px 2px  0px",
                                              },
                                            }}
                                          >
                                            {fields.map((column) => {
                                              const value = row[column.id];
                                              return (
                                                <TableCell
                                                  key={column.id}
                                                  align={column.align}
                                                >
                                                  {value}
                                                </TableCell>
                                              );
                                            })}
                                            <TableCell>
                                              <Box>
                                                <Button
                                                  disabled={isFormDisabled}
                                                  onClick={() =>
                                                    deleteAmenityId(
                                                      row.AmenityId
                                                    )
                                                  }
                                                  sx={{ padding: 0, margin: 0 }}
                                                >
                                                  <DeleteIcon
                                                    sx={{ marginRight: "0px" }}
                                                  />
                                                </Button>
                                              </Box>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                              <TablePagination
                                rowsPerPageOptions={[5, 10, 15, 100]}
                                component="div"
                                count={filteredRows.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                              />
                            </Paper>
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                  </Box>
                </>
              );
            default:
              return null;
          }
        })()}
      </Box>
    );
  };

  const handleStepClick = (step) => {
    if (mode === "view") {
      setActiveStep(step);
    }
  };

  return (
    <Grid>
      <Box className="form-container">
        <Grid container spacing={2} className="rasidant_grid">
          <Grid
            item
            xs={12}
            className="form_title"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "20px",
              flexDirection: { xs: "column", sm: "row", md: "row" },
            }}
          >
            <Grid
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-start" },
                marginBottom: { xs: "10px", sm: 0 },
              }}
            >
              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#635bff",
                  marginRight: { xs: "5px", sm: "10px" },
                  // display: { xs: "none", sm: "block" },
                }}
                className="three-d-button-previous"
                onClick={handlePrevious}
                disabled={mode !== "view"}
              >
                <KeyboardArrowLeftIcon />
              </Button>
              <Button
                variant="contained"
                size="small"
                className="three-d-button-next"
                sx={{
                  backgroundColor: "#635bff",
                  margin: "0px 10px",
                  // display: { xs: "none", sm: "block" },
                }}
                onClick={handleNextdata}
                disabled={mode !== "view"}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>

            <Typography
              variant="h5"
              sx={{
                margin: "Auto",
                textAlign: { xs: "center", sm: "center" },
                fontSize: { xs: "24px", sm: "18px", md: "24px" },
              }}
            >
              Property Master
            </Typography>
            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Property Master"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onDelete={() => handleDelete(null, true)}
                onView={handlePrint}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNextdata}
                readOnlyMode={mode === "view"}
              />
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            className="form_field"
            sx={{ marginInline: { xs: "10px", sm: "80px" } }}
          >
            <Stepper
              activeStep={activeStep}
              connector={<CustomStepConnector />}
            >
              {steps.map((label, index) => (
                <Step
                  key={label}
                  onClick={() => handleStepClick(index)}
                  style={{ cursor: mode === "view" ? "pointer" : "default" }}
                >
                  <CustomStepLabel
                    StepIconComponent={(props) => (
                      <CustomStepIcon
                        ownerState={{ ...props, active: activeStep === index }}
                      >
                        {index + 1}
                      </CustomStepIcon>
                    )}
                  >
                    {label}
                  </CustomStepLabel>
                </Step>
              ))}
            </Stepper>
          </Grid>

          <Grid item xs={12}>
            {renderStepContent(activeStep)}
          </Grid>
          {/* Buttons-Previous,next,submit,cancel */}
          <Grid
            item
            xs={12}
            className="form_button"
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "10px",
            }}
          >
            <Button
              variant="contained"
              size="small"
              sx={{
                mr: 1,
                background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
              }}
              onClick={handleBack}
              disabled={activeStep === 0 || !mode === "view"}
            >
              Previous
            </Button>
            <Button
              variant="contained"
              onClick={handleNext}
              sx={{
                mr: 1,
                background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
              }}
              disabled={mode === "view"}
            >
              {activeStep === steps.length - 1 ? "Submit" : "Next"}
            </Button>
            <Button
              variant="contained"
              onClick={handleCancel}
              disabled={mode === "view"}
              sx={{
                mr: 1,
                background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
              }}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Box>

      <ConfirmDialog
        open={isConfirmDialogOpen.isOpen}
        onClose={() => setIsConfirmDialogOpen({ isOpen: false, payload: null })}
        title="Confirm Delete"
        content="Are you sure you want to delete this data?"
        onConfirm={handleConfirmDelete}
      />
      <div style={{ display: "none" }}>
        {rows.length > 0 && (
          <ReportTable
            columns={columns}
            rows={rows.map(row => ({
              ...row,
              Status: row.Status === "1" ? "Active" : row.Status === "0" ? "Inactive" : row.Status,
            }))}
            title="Property Master"
            contentRef={contentRef}
            customStyles={{ backgroundColor: "#f5f5f5" }}
          />
        )}
      </div>
      {/* Floor Modal */}
      <Grid item xs={6} md={6} sm={6} lg={6} xl={6} className="form_field">
        <Dialog
          open={openConfirmDialog}
          onClose={closeConfirmation}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          sx={{
            "& .MuiDialog-paper": {
              maxWidth: "100%",
              width: {
                xs: "80%",
                sm: "600px",
                md: "690px",
                lg: "750px",
                xl: "800px",
              },
              height: {
                xs: "auto",
                sm: "auto",
                md: "auto",
                lg: "auto",
                xl: "auto",
              },
              padding: {
                xs: "10px",
                sm: "15px",
                md: "20px",
                lg: "20px",
                xl: "20px",
              },
              margin: {
                xs: "20px",
                sm: "40px",
                md: "60px",
                lg: "60px",
                xl: "60px",
              },
              backgroundColor: "white",
              borderRadius: "10px",
              border: "1px solid #ccc",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            },
          }}
        >
          <DialogTitle id="alert-dialog-title">
            <Grid>
              <Box
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  backgroundColor: "transparent",
                  overflow: "hidden",
                  maxHeight: {
                    xs: "50vh",
                    sm: "55vh",
                    md: "60vh",
                    lg: "65vh",
                    xl: "70vh",
                  },
                  height: {
                    xs: "50vh",
                    sm: "50vh",
                    md: "56vh",
                    lg: "60vh",
                    xl: "65vh",
                  },
                  margin: {
                    xs: "0px 0px 0px 1px",
                    sm: "0px 0px 0px 2.5px",
                    md: "0px 0px 0px 2.5px",
                    lg: "0px 0px 0px 2.5px",
                    xl: "0px 0px 0px 2.5px",
                  },
                  padding: {
                    xs: "0px",
                    sm: "0px",
                    md: "0px",
                    lg: "0px",
                    xl: "0px",
                  },
                  gap: 2,
                  maxWidth: {
                    xs: "100%",
                    sm: "90vw",
                    md: "80vw",
                    lg: "70vw",
                    xl: "60vw",
                  },
                }}
              >
                {/* Your content goes here */}
                <Grid container spacing={0}>
                  <Grid
                    item
                    xs={6}
                    md={6}
                    sm={6}
                    lg={6}
                    xl={6}
                    className="form_field"
                  >
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "1.25rem",
                          sm: "1.5rem",
                          md: "1.75rem",
                          lg: "2rem",
                          xl: "2.25rem",
                        },
                        fontWeight: 500,
                        marginInline: "auto",
                        width: "fit-content",
                      }}
                    >
                      Wings
                    </Typography>
                    <Grid>
                      {/* Search Box */}
                      <Box
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "2px",
                        }}
                      >
                        <TextField
                          placeholder="Search for a wing..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          sx={{
                            width: "80.5%",
                            padding: "7.5px",
                            marginBottom: "0px",
                            borderRadius: "5px",
                            marginLeft: "25px",
                          }}
                          variant="outlined"
                          InputProps={{
                            endAdornment: !isFormDisabled && (
                              <InputAdornment position="end">
                                <AddIcon
                                  onClick={openWingTab}
                                  style={{ cursor: "pointer", fontSize: '16px', color: '#2196f3' }}
                                />
                                <RefreshIcon
                                  onClick={handleRefreshWings}
                                  sx={{
                                    transition: 'transform 0.3s ease',
                                    cursor: 'pointer',
                                    fontSize: '18px',
                                    color: '#4caf50',
                                  }}
                                  style={spinAnimationWing}
                                />
                                <style>
                                  {`
          @keyframes spin {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
        `}
                                </style>
                              </InputAdornment>
                            ),
                          }}
                        />
                        <FilterAltIcon
                          style={{ color: "#888", cursor: "pointer" }}
                          onClick={handleClearAllSelections}
                        />
                      </Box>
                      <List
                        sx={{
                          maxHeight: "40vh",
                          minWidth: "200px",
                          overflow: "auto",
                          paddingLeft: "30px",
                        }}
                      >
                        {filteredWings.map((item) => (
                          <ListItem
                            key={item.Id}
                            sx={{
                              margin: 0,
                              padding: 0,
                              backgroundColor: item.isChecked
                                ? "#e0f7fa"
                                : "#a7c5e9",
                              border: "1px solid #ccc",
                              borderRadius: "8px",
                              width: {
                                xs: "85.5%",
                                sm: "86%",
                                md: "85.5%",
                                lg: "85%",
                                xl: "84.5%",
                              },
                              marginBottom: "5px",
                              "&:hover": {
                                backgroundColor: "#dddbff",
                              },
                            }}
                          >
                            <label>
                              <input
                                type="radio"
                                name="wing"
                                id={"wing" + item.Id}
                                checked={item.isChecked}
                                onChange={() => wingCheckboxChange(item.Id)}
                              />
                              {item.Name}
                            </label>
                          </ListItem>
                        ))}
                      </List>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    md={6}
                    sm={6}
                    lg={6}
                    xl={6}
                    className="form_field"
                  >
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "1.25rem",
                          sm: "1.5rem",
                          md: "1.75rem",
                          lg: "2rem",
                          xl: "2.25rem",
                        },
                        fontWeight: 500,
                        marginInline: "auto",
                        width: "fit-content",
                      }}
                    >
                      Floors
                    </Typography>
                    <Grid>
                      {/* Search Box */}
                      <Box
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "2px",
                        }}
                      >
                        <TextField
                          placeholder="Search for a floor..."
                          value={searchFloorQuery}
                          onChange={(e) => setSearchFloorQuery(e.target.value)}
                          sx={{
                            width: "78%",
                            padding: "7.5px",
                            marginBottom: "0px",
                            borderRadius: "5px",
                            marginLeft: "25px",
                          }}
                          variant="outlined"
                          InputProps={{
                            endAdornment: !isFormDisabled && (
                              <InputAdornment position="end">
                                <AddIcon
                                  onClick={openFloorTab}
                                  style={{ cursor: "pointer", fontSize: '16px', color: '#2196f3' }}
                                />
                                <RefreshIcon
                                  onClick={handleRefreshFloors}
                                  sx={{
                                    transition: 'transform 0.3s ease',
                                    cursor: 'pointer',
                                    fontSize: '18px',
                                    color: '#4caf50',
                                  }}
                                  style={spinAnimationFloor}
                                />
                                <style>
                                  {`
          @keyframes spin {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
        `}
                                </style>
                              </InputAdornment>
                            ),
                          }}
                        />
                        <FilterAltIcon
                          style={{ color: "#888", cursor: "pointer" }}
                          onClick={handleClearAllFloorSelections}
                        />
                      </Box>

                      <List
                        sx={{
                          maxHeight: "40vh",
                          minWidth: "200px",
                          overflowX: "auto",
                          paddingLeft: "30px",
                        }}
                      >
                        {/* Filtered Floors List */}
                        {filteredFloors.map((item) => (
                          <ListItem
                            key={item.Id}
                            sx={{
                              margin: 0,
                              padding: 0,
                              backgroundColor: item.isChecked
                                ? "#e0f7fa"
                                : "#a7c5e9",
                              border: "1px solid #ccc",
                              borderRadius: "8px",
                              width: {
                                xs: "83.5%",
                                sm: "83.5%",
                                md: "83%",
                                lg: "87%",
                                xl: "88%",
                              },
                              marginBottom: "5px",
                              "&:hover": {
                                backgroundColor: "#dddbff",
                              },
                            }}
                          >
                            <label>
                              <input
                                type="checkbox"
                                checked={item.isChecked}
                                onChange={() => handleCheckboxChange(item.Id)} // Handler for individual checkbox
                              />
                              {item.Name}
                            </label>
                          </ListItem>
                        ))}
                      </List>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </DialogTitle>

          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              paddingBottom: "10px",
            }}
          >
            <Grid container spacing={2} justifyContent="flex-end" gap={0}>
              <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                <Button
                  sx={{
                    backgroundColor: "#635BFF",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "#dddbff",
                      color: "white",
                    },
                  }}
                  onClick={handleSelect}
                >
                  Confirm
                </Button>
              </Grid>

              <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                <Button
                  sx={{
                    backgroundColor: "#635BFF",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "#dddbff",
                      color: "white",
                    },
                  }}
                  onClick={closeConfirmation}
                >
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
      </Grid>
    </Grid>
  );
};

export default StepperForm;
